import React from 'react'
import CountryPicker from '../CountryPicker/CountryPicker'
import { className } from '../../../../Utils'
import './MenuMobileFooter.css'
import { useSelector } from 'react-redux';

const socialLinks = (language) => [
    {
        id: 1,
        href: language === 'bg'
            ? 'https://www.facebook.com/FeiaBulgaria'
            : 'https://www.facebook.com/gaiapregnancyapp/',
        iconClassName: 'menu-fb',
        label: 'Facebook'
    },
    {
        id: 2,
        href: language === 'bg'
            ? 'https://www.instagram.com/feia_bulgaria'
            : 'https://www.instagram.com/gaia_pregnancy_app',
        iconClassName: 'menu-insta',
        label: 'Instagram'
    },
    {
        id: 3,
        href: 'tel:0877833111',
        iconClassName: 'menu-phone',
        label: 'Phone'
    },
    {
        id: 4,
        href: 'mailto:office@feia.bg',
        iconClassName: 'menu-mail',
        label: 'Email'
    }
]


const MenuMobileFooter = () => {
    const { language } = useSelector((state) => state.home)

    return (
        <div className={"menuFooter"}>
            <div className={className('menu-footer-container')}>
                {socialLinks(language).map((item) => (
                    <a key={item.id}
                        href={item.href}
                        className="social-icon-Mobile"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <div className={item.iconClassName} />
                    </a>
                ))}
            </div>
            <div className='country-picker-mobile-container'>
                <CountryPicker />
            </div>
        </div>
    )
}

export default MenuMobileFooter